import { render, staticRenderFns } from "./ConflictMultipleChoiceField.vue?vue&type=template&id=1a8aa6c0&scoped=true"
import script from "./ConflictMultipleChoiceField.vue?vue&type=script&lang=js"
export * from "./ConflictMultipleChoiceField.vue?vue&type=script&lang=js"
import style0 from "./ConflictMultipleChoiceField.vue?vue&type=style&index=0&id=1a8aa6c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8aa6c0",
  null
  
)

export default component.exports